const auth = {
    redirectToOfficialSite: 'Authentication failed. Redirecting to the official site.',
    redirectReasons: {
      signInInitFailed: 'The sign-in service is unavailable. Redirecting to the official site.',
      restoreAuthFailed: 'Failed to restore your sign-in state. Redirecting to the official site.',
      missingAuthState: 'No valid sign-in state was found. Redirecting to the official site.',
      callbackFailed: 'Failed to complete the sign-in callback. Redirecting to the official site.',
      callbackSdkError:
        'The authentication callback returned an error. Redirecting to the official site.',
      callbackTimeout: 'The sign-in callback timed out. Redirecting to the official site.',
      apiUnauthorized: 'Your session has expired. Redirecting to the official site.',
      logtoUnauthorized:
        'Your authentication session has expired. Redirecting to the official site.',
    },
  }

export default auth
